export function OutlinePautaInteligenteIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.032 15.0023L13.5321 9.00391L16.0322 15.0023"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3128 13.2891H11.7473"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.03271 15.0023V9.00391"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0603 18.9989V8.83045C19.0603 8.29779 18.8491 7.79392 18.4748 7.41482L14.6454 3.58544C14.2711 3.21114 13.7625 3 13.2298 3H7.00107C5.89736 3 5 3.89736 5 5.00107V18.9989C5 20.1026 5.89736 21 7.00107 21H17.064C18.1677 21 19.0651 20.1026 19.0651 18.9989H19.0603Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
